
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/articles",
      function () {
        return require("private-next-pages/destinations/articles.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/articles"])
      });
    }
  